import { Component, Input, OnChanges } from '@angular/core';
import { MoodBasic } from '@rhinosaas/reb-ngx/reb-ngx-shared/tokens/palette';

@Component({
  selector: 'app-status-chip',
  templateUrl: './status-chip.component.html',
})

export class StatusChipComponent implements OnChanges {
  mood: MoodBasic = 'default';

  @Input() status: string = '';

  constructor() {}

  setStylesByStatus(status: string) {
    switch (status) {
      case 'active':
      case 'done':
      case 'paid':
      case 'settled':
      case 'success':
        this.mood = 'success';
        break;
      case 'archived':
      case 'draft':
      case 'disabled':
      case 'paused':
      case 'pending':
      case 'processing':
        this.mood = 'default';
        break;
      case 'cancelled':
      case 'error':
      case 'paymentDue':
        this.mood = 'error';
        break;
      case 'dunning':
      case 'partialRefund':
      case 'requestPayment':
      case 'requiredAuthorization':
      case 'refund':
      case 'running':
        this.mood = 'warning';
        break;
      case 'created':
      case 'partialPaid':
      case 'posted':
      case 'published':
      case 'ready':
        this.mood = 'info';
        break;
    }
  }

  ngOnChanges() {
    this.setStylesByStatus(this.status);
  }
}
